import useScrollReveal from '../useScrollReveal';
import { sectionStyles, isCardTransparent, getAnimation } from '../utils';
import SectionHeader from './SectionHeader';
import SectionDivider from './SectionDivider';

export default function DataTableSection({ block = {}, primaryColor, secondaryColor, enableAnimations, cardStyle }) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor);
    const [ref, visible] = useScrollReveal(0.15, !enableAnimations);
    const headers = content.headers || [];
    const rows = content.rows || [];
    const anim = getAnimation(config, visible);
    const tp = isCardTransparent(cardStyle, s.dark);
    const variant = config.variant || 'striped';

    if (headers.length === 0 || rows.length === 0) return null;

    const cls = `${s.padClass} relative ${s.radiusClass} ${s.shadowClass}`;
    const bgS = s.bgStyle.background ? s.bgStyle : { backgroundColor: s.bg || '#ffffff', ...s.bgStyle };

    const positiveColor = config.positive_color || '#22c55e';
    const negativeColor = config.negative_color || '#f87171';

    const cellValue = (val) => {
        if (val === '✓') return <span className="font-bold text-lg" style={{ color: positiveColor }}>✓</span>;
        if (val === '✗') return <span className="font-bold text-lg" style={{ color: negativeColor }}>✗</span>;
        return val;
    };

    return (
        <section className={cls} style={bgS}>
            <SectionDivider type={config.divider_top} color="transparent" position="top"  config={config}/>
            <div ref={ref} className={`${s.maxWidth} mx-auto px-4 sm:px-6 lg:px-8 ${anim}`}>
                <SectionHeader tag={content.tag} title={content.title} subtitle={content.subtitle} config={config} s={s} />
                <div className={`overflow-x-auto transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
                    <table className="w-full min-w-[500px]">
                        <thead>
                            <tr>
                                {headers.map((h, i) => (
                                    <th key={i} className={`px-4 py-3 text-sm font-bold text-left ${i === 0 ? '' : 'text-center'}`}
                                        style={{ color: i === 2 ? s.accent : s.text, borderBottom: tp ? '1px solid rgba(255,255,255,0.1)' : '2px solid ' + (s.dark ? 'rgba(255,255,255,0.1)' : '#e5e7eb') }}>
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, ri) => {
                                const cells = Array.isArray(row) ? row : Object.values(row);
                                return (
                                    <tr key={ri} style={variant === 'striped' && ri % 2 === 0 ? { backgroundColor: s.dark ? 'rgba(255,255,255,0.05)' : '#f9fafb' } : undefined}>
                                        {cells.map((cell, ci) => (
                                            <td key={ci} className={`px-4 py-3 text-sm ${ci === 0 ? 'font-medium' : 'text-center'}`}
                                                style={{ color: ci === 0 ? s.text : s.textSub, borderBottom: s.dark ? '1px solid rgba(255,255,255,0.05)' : '1px solid #f3f4f6' }}>
                                                {cellValue(cell)}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <SectionDivider type={config.divider_bottom} color={config.divider_bottom_color || '#ffffff'} position="bottom"  config={config}/>
        </section>
    );
}
